<script setup lang="ts">
import { useAppStore } from '@/stores/app.store'
import { useLoadingMessages } from '@/composables/useLoadingMessages'
import RadarSpinner from './RadarSpinner.vue'

// Full-screen blocking loader, mounted once in App.vue and driven entirely by
// the app store (see useGlobalLoader for the imperative API).
const store = useAppStore()
const { message } = useLoadingMessages(() => store.loadingContext)
</script>

<template>
	<Teleport to="body">
		<Transition name="fade">
			<div
				v-if="store.loading"
				class="global-loader"
				role="status"
				aria-live="polite"
			>
				<RadarSpinner :size="56" />
				<Transition
					name="fade"
					mode="out-in"
				>
					<p
						:key="message"
						class="global-loader__message"
					>
						{{ message }}
					</p>
				</Transition>
			</div>
		</Transition>
	</Teleport>
</template>

<style scoped lang="scss">
// z-index 2900: above Vuetify's overlay stack (starts at 2000, +10 per overlay)
// and the ai-replace modal (2400), below route progress (3000) / toasts (3100).
.global-loader {
	position: fixed;
	inset: 0;
	z-index: 2900;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
	background: rgba(var(--v-theme-surface), 0.85);
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);

	&__message {
		margin: 0;
		font-size: 0.9375rem;
		font-weight: 500;
		color: rgba(var(--v-theme-on-surface), 0.75);
	}
}

@media (prefers-reduced-transparency: reduce) {
	.global-loader {
		background: rgb(var(--v-theme-surface));
		backdrop-filter: none;
		-webkit-backdrop-filter: none;
	}
}
</style>
